type InquiryLike = { id?: unknown };

/**
 * Move the matching inquiry to the front of the sidebar list.
 * Returns the original array when the id is missing, unknown, or already first
 * so callers can skip a needless re-render.
 */
export const moveInquiryToTop = <T extends InquiryLike>(
  inquiries: T[],
  inquiryId: string | number | null | undefined,
): T[] => {
  if (inquiryId == null || inquiries.length === 0) {
    return inquiries;
  }

  const target = String(inquiryId);
  const index = inquiries.findIndex(item => String(item.id) === target);

  if (index < 0 || index === 0) {
    return inquiries;
  }

  const next = inquiries.slice();
  const [item] = next.splice(index, 1);
  next.unshift(item);

  return next;
};

export const restoreInquiryPosition = <T extends InquiryLike>(
  inquiries: T[],
  inquiryId: string | number,
  fromIndex: number,
): T[] => {
  const target = String(inquiryId);
  const current = inquiries.findIndex(item => String(item.id) === target);

  if (current < 0 || current === fromIndex) {
    return inquiries;
  }

  const next = inquiries.slice();
  const [item] = next.splice(current, 1);
  const clamped = Math.max(0, Math.min(fromIndex, next.length));
  next.splice(clamped, 0, item);

  return next;
};
